export default "assets/images/grainy_bg-0a37c355.jpg";